import React from "react";
import {
  Box,
  Grid,
  Typography,
  Container,
  useTheme,
} from "@mui/material";
import InfoSection from "../../shared/InfoSection";
import img from "../../../assets/images/circle-info.png";
import service1 from "../../../assets/images/service1.png";
import service2 from "../../../assets/images/service2.png";
import { useTranslation } from "react-i18next";
const logos = [
  { src: service2, alt: "Ministry of Commerce Logo" },
  { src: service1, alt: "SOCPA Logo" },
];
const ZakatConsultancyAbout = ({data}) => {

  const theme = useTheme();
  const { i18n, t } = useTranslation();
  const currentLang = i18n.language;
  return (
    <Container maxWidth="lg">
      <Box
        sx={{
          textAlign: "center",
          padding: "32px 0",
          overflow:"hidden"
        }}
      >
        <Grid
          container
          spacing={4}
          justifyContent="center"
          alignItems="stretch"
        >
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                borderRadius: "8px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                overflow: "hidden",
              }}
            >
              <img
                src={data?.image}
                alt="Company Building"
                style={{
                  borderRadius: "8px",
                  width: "100%",
                  maxWidth: "479px",
                  height: currentLang ==="en"?"608px":"550px",
                  objectFit: "cover",
                }}
              />
            </Box>
          </Grid>

          <Grid
            item
            xs={12}
            md={6}
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "flex-start",
              height: "100%",
            }}
          >
            <InfoSection
              icon={img}
              title={t("buttons.Who We Are")}              description={data?.title[currentLang]}
              align="flex-start"
              textAlign={currentLang === "ar"?"right":"left"}            />

            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-start",
                gap: { xs: 0.5, sm: 2, md: 2 },
                marginTop: "40px",
                marginBottom: "40px",
                flexDirection: { xs: "column", sm: "row" },
                alignItems: "center",
                width: "100%",
              }}
            >
              {logos.map((logo, index) => (
                <Box
                  key={index}
                  sx={{
                    width: { xs: "90%", sm: "180px", md: "256px" },
                    height: { xs: "auto", md: "88px" },
                    border: "1px solid #D6D8DB",
                    borderRadius: "12px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: 1,
                    marginBottom: { xs: 2, md: 0 },
                  }}
                >
                  <img
                    src={logo.src}
                    alt={logo.alt}
                    style={{
                      width: { xs: "120px", sm: "150px", md: "182px" },
                      maxHeight: "85px",
                      marginRight: logo.alt === "SOCPA Logo" ? "8px" : "0px",
                    }}
                  />
                </Box>
              ))}
            </Box>

            <Typography
              sx={{
                color: theme.palette.primary.body,
                fontWeight: "400",
                fontSize: "18px",
                lineHeight: {xs:"normal",md:"27px"},
                marginBottom: "35px",
                textAlign: currentLang === "ar" ? "right" : "left",

              }}
            >
            {data?.description[currentLang]}
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};

export default ZakatConsultancyAbout;
